import type { ChatPresentation } from '~/components/AiChat/controller/types';

export const ASSISTANT_TEXTS = {
  TAB_LABEL: 'Configuration Assistant',
} as const;

export const ASSISTANT_PRESENTATION: ChatPresentation = {
  assistantName: 'Configuration Assistant',
  greeting:
    'Describe the configuration change you want for this organization. The assistant drafts it, asks you to confirm, and leaves a pending promotion for review in the Promotions tab.',
  placeholder: 'Ask the assistant to change this organization’s configuration…',
  disclaimer: 'The assistant can make mistakes. Review each change in the Promotions tab before approving it.',
  failedText: 'The assistant could not answer this message.',
};
